export const formatNumber = (number, c) => {
    return new Intl.NumberFormat('en-en', { style: 'currency', currency: c }).format(number);
}